import { render } from "./AdminLayouts.vue?vue&type=template&id=30d5b0ea"
import script from "./AdminLayouts.vue?vue&type=script&lang=js"
export * from "./AdminLayouts.vue?vue&type=script&lang=js"

import "./AdminLayouts.vue?vue&type=style&index=0&id=30d5b0ea&lang=scss"
script.render = render

export default script